/* Personal daily encouragement — life hope, not business advice. {name} placeholder */

const MOTIVATIONAL_QUOTES = [
    {
        "en": "{name}, if you feel down today, you can rise again tomorrow.",
        "ar": "{name}، إذا كنت منخفضًا اليوم، يمكنك أن تنهض غدًا."
    },
    {
        "en": "{name}, losing today does not mean you won't win tomorrow.",
        "ar": "{name}، خسارتك اليوم لا تعني أنك لن تفوز غدًا."
    },
    {
        "en": "Hard days pass, {name}. Softer days are coming.",
        "ar": "الأيام الصعبة تمر يا {name}. أيام ألطف قادمة."
    },
    {
        "en": "{name}, your storm is temporary — your strength is not.",
        "ar": "{name}، عاصفتك مؤقتة — لكن قوتك ليست كذلك."
    },
    {
        "en": "Even if today was heavy, {name}, tomorrow can be lighter.",
        "ar": "حتى لو كان اليوم ثقيلًا يا {name}، قد يكون الغد أخف."
    },
    {
        "en": "{name}, falling is human. Rising again is courage.",
        "ar": "{name}، السقوط أمر بشري. النهوض مرة أخرى شجاعة."
    },
    {
        "en": "You are allowed to rest, {name}, and still be strong.",
        "ar": "يحق لك أن ترتاح يا {name}، وأن تبقى قويًا."
    },
    {
        "en": "{name}, this chapter is hard, but it is not the whole story.",
        "ar": "{name}، هذا الفصل صعب، لكنه ليس القصة كلها."
    },
    {
        "en": "Hold on, {name}. Dawn always follows the darkest hour.",
        "ar": "تمسّك يا {name}. الفجر يأتي دائمًا بعد أحلك ساعة."
    },
    {
        "en": "{name}, tears today can water growth tomorrow.",
        "ar": "{name}، دموع اليوم قد تسقي نمو الغد."
    },
    {
        "en": "You have survived every hard day so far, {name}.",
        "ar": "لقد نجوت من كل يوم صعب حتى الآن يا {name}."
    },
    {
        "en": "{name}, broken feelings do not mean a broken future.",
        "ar": "{name}، المشاعر المكسورة لا تعني مستقبلًا مكسورًا."
    },
    {
        "en": "Be gentle with yourself today, {name}. Healing takes time.",
        "ar": "كن لطيفًا مع نفسك اليوم يا {name}. الشفاء يحتاج وقتًا."
    },
    {
        "en": "{name}, one bad day cannot erase all your good days.",
        "ar": "{name}، يوم سيئ واحد لا يمحو كل أيامك الجيدة."
    },
    {
        "en": "If your heart is tired, {name}, let hope carry it for a while.",
        "ar": "إذا كان قلبك متعبًا يا {name}، دع الأمل يحمله قليلًا."
    },
    {
        "en": "{name}, you are more than what went wrong today.",
        "ar": "{name}، أنت أكبر مما أخطأ اليوم."
    },
    {
        "en": "Tomorrow is a blank page, {name}. You still get to write it.",
        "ar": "الغد صفحة بيضاء يا {name}. ما زال بإمكانك كتابتها."
    },
    {
        "en": "{name}, the night feels long, but mornings always return.",
        "ar": "{name}، الليل يبدو طويلًا، لكن الصباح يعود دائمًا."
    },
    {
        "en": "Pain is loud today, {name}, but it will not speak forever.",
        "ar": "الألم مرتفع اليوم يا {name}، لكنه لن يتكلم إلى الأبد."
    },
    {
        "en": "{name}, keep breathing. Better air is ahead.",
        "ar": "{name}، واصل التنفس. هواء أفضل في الطريق."
    },
    {
        "en": "{name}, the sun still knows your name after the rain.",
        "ar": "{name}، الشمس ما زالت تعرف اسمك بعد المطر."
    },
    {
        "en": "You are still becoming, {name}. That is enough for today.",
        "ar": "ما زلت تصبح أفضل يا {name}. وهذا يكفي لليوم."
    },
    {
        "en": "{name}, your lowest day can still grow into your strongest season.",
        "ar": "{name}، أخفض يوم لك قد ينمو إلى أقوى موسم."
    },
    {
        "en": "Do not judge your whole life by one evening, {name}.",
        "ar": "لا تحكم على حياتك كلها من مساء واحد يا {name}."
    },
    {
        "en": "{name}, some nights teach the heart how to hope again.",
        "ar": "{name}، بعض الليالي تعلّم القلب كيف يأمل من جديد."
    },
    {
        "en": "You can feel broken and still be worthy, {name}.",
        "ar": "يمكنك أن تشعر بالانكسار وتبقى جديرًا يا {name}."
    },
    {
        "en": "{name}, slow healing is still healing.",
        "ar": "{name}، الشفاء البطيء ما زال شفاءً."
    },
    {
        "en": "Your softness is not weakness, {name}.",
        "ar": "رقتك ليست ضعفًا يا {name}."
    },
    {
        "en": "{name}, even quiet courage counts.",
        "ar": "{name}، حتى الشجاعة الهادئة تُحتسب."
    },
    {
        "en": "Let today end, {name}. Let tomorrow open.",
        "ar": "دع اليوم ينتهي يا {name}. ودع الغد يُفتح."
    },
    {
        "en": "{name}, you do not have to bloom every day to stay alive.",
        "ar": "{name}، لست مضطرًا أن تزهر كل يوم لتبقى حيًا."
    },
    {
        "en": "Scars can become maps, {name}.",
        "ar": "الندوب قد تصبح خرائط يا {name}."
    },
    {
        "en": "{name}, you are allowed to start over as many times as you need.",
        "ar": "{name}، يحق لك أن تبدأ من جديد بقدر ما تحتاج."
    },
    {
        "en": "The version of you that keeps going is already brave, {name}.",
        "ar": "النسخة منك التي تواصل المضي شجاعة أصلًا يا {name}."
    },
    {
        "en": "{name}, what hurts now can teach you how to love yourself better.",
        "ar": "{name}، ما يؤلم الآن قد يعلّمك كيف تحب نفسك أفضل."
    },
    {
        "en": "You are not late, {name}. You are on your path.",
        "ar": "لست متأخرًا يا {name}. أنت على طريقك."
    },
    {
        "en": "{name}, hold the morning like a second chance.",
        "ar": "{name}، امسك الصباح كفرصة ثانية."
    },
    {
        "en": "Some victories are just surviving the night, {name}.",
        "ar": "بعض الانتصارات هي مجرد النجاة من الليل يا {name}."
    },
    {
        "en": "{name}, your heart can learn light again.",
        "ar": "{name}، قلبك يمكن أن يتعلّم النور من جديد."
    },
    {
        "en": "Be patient with your becoming, {name}.",
        "ar": "كن صبورًا مع صيرورتك يا {name}."
    },
    {
        "en": "{name}, if today feels dark, tomorrow can still lift you.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Hey {name}, if today feels dark, tomorrow can still lift you.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name} — if today feels dark, tomorrow can still lift you.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Dear {name}, if today feels dark, tomorrow can still lift you.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name}, if today feels dark, a softer day can still find you.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "Hey {name}, if today feels dark, a softer day can still find you.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name} — if today feels dark, a softer day can still find you.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "Dear {name}, if today feels dark, a softer day can still find you.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name}, if today feels dark, winning can still be near.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "Hey {name}, if today feels dark, winning can still be near.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name} — if today feels dark, winning can still be near.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "Dear {name}, if today feels dark, winning can still be near.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name}, if today feels dark, light can return without warning.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Hey {name}, if today feels dark, light can return without warning.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name} — if today feels dark, light can return without warning.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Dear {name}, if today feels dark, light can return without warning.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name}, if today feels dark, you can begin again.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Hey {name}, if today feels dark, you can begin again.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name} — if today feels dark, you can begin again.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Dear {name}, if today feels dark, you can begin again.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name}, if today feels dark, your story is not finished.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Hey {name}, if today feels dark, your story is not finished.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name} — if today feels dark, your story is not finished.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Dear {name}, if today feels dark, your story is not finished.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name}, if today feels dark, hope can grow back.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Hey {name}, if today feels dark, hope can grow back.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name} — if today feels dark, hope can grow back.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Dear {name}, if today feels dark, hope can grow back.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name}, if today feels dark, strength can wake with the morning.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Hey {name}, if today feels dark, strength can wake with the morning.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name} — if today feels dark, strength can wake with the morning.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Dear {name}, if today feels dark, strength can wake with the morning.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name}, if today feels dark, joy can visit again.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Hey {name}, if today feels dark, joy can visit again.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name} — if today feels dark, joy can visit again.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Dear {name}, if today feels dark, joy can visit again.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name}, if today feels dark, healing is already on the way.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Hey {name}, if today feels dark, healing is already on the way.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name} — if today feels dark, healing is already on the way.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Dear {name}, if today feels dark, healing is already on the way.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name}, if today feels dark, you can rise from this.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "Hey {name}, if today feels dark, you can rise from this.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name} — if today feels dark, you can rise from this.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "Dear {name}, if today feels dark, you can rise from this.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name}, if today feels dark, peace can come back to you.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالسلام قد يعود إليك."
    },
    {
        "en": "Hey {name}, if today feels dark, peace can come back to you.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالسلام قد يعود إليك."
    },
    {
        "en": "{name} — if today feels dark, peace can come back to you.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالسلام قد يعود إليك."
    },
    {
        "en": "Dear {name}, if today feels dark, peace can come back to you.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالسلام قد يعود إليك."
    },
    {
        "en": "{name}, if today feels dark, better moments are waiting.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Hey {name}, if today feels dark, better moments are waiting.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name} — if today feels dark, better moments are waiting.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Dear {name}, if today feels dark, better moments are waiting.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name}, if today feels dark, you are allowed a new chance.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "Hey {name}, if today feels dark, you are allowed a new chance.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name} — if today feels dark, you are allowed a new chance.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "Dear {name}, if today feels dark, you are allowed a new chance.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name}, if today feels dark, the next chapter can be kinder.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Hey {name}, if today feels dark, the next chapter can be kinder.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name} — if today feels dark, the next chapter can be kinder.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Dear {name}, if today feels dark, the next chapter can be kinder.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name}, if today feels dark, your heart can recover.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Hey {name}, if today feels dark, your heart can recover.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name} — if today feels dark, your heart can recover.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Dear {name}, if today feels dark, your heart can recover.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name}, if today feels dark, grace can meet you tomorrow.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Hey {name}, if today feels dark, grace can meet you tomorrow.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name} — if today feels dark, grace can meet you tomorrow.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Dear {name}, if today feels dark, grace can meet you tomorrow.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name}, if today feels dark, you will not stay here forever.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Hey {name}, if today feels dark, you will not stay here forever.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name} — if today feels dark, you will not stay here forever.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Dear {name}, if today feels dark, you will not stay here forever.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name}, if today feels dark, the sky can clear again.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Hey {name}, if today feels dark, the sky can clear again.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name} — if today feels dark, the sky can clear again.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Dear {name}, if today feels dark, the sky can clear again.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name}, if today feels dark, you can feel whole again.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Hey {name}, if today feels dark, you can feel whole again.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name} — if today feels dark, you can feel whole again.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Dear {name}, if today feels dark, you can feel whole again.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name}, if today feels dark, life can surprise you kindly.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Hey {name}, if today feels dark, life can surprise you kindly.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name} — if today feels dark, life can surprise you kindly.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Dear {name}, if today feels dark, life can surprise you kindly.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name}, if today feels dark, you can breathe easier soon.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Hey {name}, if today feels dark, you can breathe easier soon.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name} — if today feels dark, you can breathe easier soon.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Dear {name}, if today feels dark, you can breathe easier soon.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name}, if today feels dark, your smile can return naturally.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Hey {name}, if today feels dark, your smile can return naturally.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name} — if today feels dark, your smile can return naturally.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Dear {name}, if today feels dark, your smile can return naturally.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name}, if today feels dark, the weight can get lighter.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "Hey {name}, if today feels dark, the weight can get lighter.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name} — if today feels dark, the weight can get lighter.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "Dear {name}, if today feels dark, the weight can get lighter.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name}, if today feels dark, you can stand taller again.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Hey {name}, if today feels dark, you can stand taller again.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "{name} — if today feels dark, you can stand taller again.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Dear {name}, if today feels dark, you can stand taller again.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "{name}, if today feels dark, a fresh start is still yours.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "Hey {name}, if today feels dark, a fresh start is still yours.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "{name} — if today feels dark, a fresh start is still yours.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "Dear {name}, if today feels dark, a fresh start is still yours.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "{name}, if today feels dark, you can find yourself again.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "Hey {name}, if today feels dark, you can find yourself again.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "{name} — if today feels dark, you can find yourself again.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "Dear {name}, if today feels dark, you can find yourself again.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "{name}, if today feels dark, tomorrow can rewrite today.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "Hey {name}, if today feels dark, tomorrow can rewrite today.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "{name} — if today feels dark, tomorrow can rewrite today.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "Dear {name}, if today feels dark, tomorrow can rewrite today.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "{name}, if today feels dark, you are not alone in this.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فلست وحدك في هذا."
    },
    {
        "en": "Hey {name}, if today feels dark, you are not alone in this.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فلست وحدك في هذا."
    },
    {
        "en": "{name} — if today feels dark, you are not alone in this.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فلست وحدك في هذا."
    },
    {
        "en": "Dear {name}, if today feels dark, you are not alone in this.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فلست وحدك في هذا."
    },
    {
        "en": "{name}, if today feels dark, your future still believes in you.",
        "ar": "{name}، إذا بدا اليوم مظلمًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "Hey {name}, if today feels dark, your future still believes in you.",
        "ar": "يا {name}، إذا بدا اليوم مظلمًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "{name} — if today feels dark, your future still believes in you.",
        "ar": "{name} — إذا بدا اليوم مظلمًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "Dear {name}, if today feels dark, your future still believes in you.",
        "ar": "عزيزي {name}، إذا بدا اليوم مظلمًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "{name}, if your heart feels heavy, tomorrow can still lift you.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, tomorrow can still lift you.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name} — if your heart feels heavy, tomorrow can still lift you.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, tomorrow can still lift you.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name}, if your heart feels heavy, a softer day can still find you.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, a softer day can still find you.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name} — if your heart feels heavy, a softer day can still find you.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, a softer day can still find you.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name}, if your heart feels heavy, winning can still be near.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, winning can still be near.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name} — if your heart feels heavy, winning can still be near.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, winning can still be near.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name}, if your heart feels heavy, light can return without warning.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, light can return without warning.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name} — if your heart feels heavy, light can return without warning.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, light can return without warning.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name}, if your heart feels heavy, you can begin again.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you can begin again.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name} — if your heart feels heavy, you can begin again.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you can begin again.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name}, if your heart feels heavy, your story is not finished.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, your story is not finished.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name} — if your heart feels heavy, your story is not finished.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, your story is not finished.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name}, if your heart feels heavy, hope can grow back.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, hope can grow back.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name} — if your heart feels heavy, hope can grow back.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, hope can grow back.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name}, if your heart feels heavy, strength can wake with the morning.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, strength can wake with the morning.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name} — if your heart feels heavy, strength can wake with the morning.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, strength can wake with the morning.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name}, if your heart feels heavy, joy can visit again.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, joy can visit again.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name} — if your heart feels heavy, joy can visit again.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, joy can visit again.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name}, if your heart feels heavy, healing is already on the way.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, healing is already on the way.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name} — if your heart feels heavy, healing is already on the way.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, healing is already on the way.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name}, if your heart feels heavy, you can rise from this.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you can rise from this.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name} — if your heart feels heavy, you can rise from this.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you can rise from this.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name}, if your heart feels heavy, peace can come back to you.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالسلام قد يعود إليك."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, peace can come back to you.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالسلام قد يعود إليك."
    },
    {
        "en": "{name} — if your heart feels heavy, peace can come back to you.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالسلام قد يعود إليك."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, peace can come back to you.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالسلام قد يعود إليك."
    },
    {
        "en": "{name}, if your heart feels heavy, better moments are waiting.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, better moments are waiting.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name} — if your heart feels heavy, better moments are waiting.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, better moments are waiting.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name}, if your heart feels heavy, you are allowed a new chance.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you are allowed a new chance.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name} — if your heart feels heavy, you are allowed a new chance.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you are allowed a new chance.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name}, if your heart feels heavy, the next chapter can be kinder.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, the next chapter can be kinder.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name} — if your heart feels heavy, the next chapter can be kinder.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, the next chapter can be kinder.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name}, if your heart feels heavy, your heart can recover.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, your heart can recover.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name} — if your heart feels heavy, your heart can recover.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, your heart can recover.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name}, if your heart feels heavy, grace can meet you tomorrow.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, grace can meet you tomorrow.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name} — if your heart feels heavy, grace can meet you tomorrow.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, grace can meet you tomorrow.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name}, if your heart feels heavy, you will not stay here forever.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you will not stay here forever.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name} — if your heart feels heavy, you will not stay here forever.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you will not stay here forever.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name}, if your heart feels heavy, the sky can clear again.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, the sky can clear again.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name} — if your heart feels heavy, the sky can clear again.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, the sky can clear again.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name}, if your heart feels heavy, you can feel whole again.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you can feel whole again.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name} — if your heart feels heavy, you can feel whole again.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you can feel whole again.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name}, if your heart feels heavy, life can surprise you kindly.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, life can surprise you kindly.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name} — if your heart feels heavy, life can surprise you kindly.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, life can surprise you kindly.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name}, if your heart feels heavy, you can breathe easier soon.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you can breathe easier soon.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name} — if your heart feels heavy, you can breathe easier soon.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you can breathe easier soon.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name}, if your heart feels heavy, your smile can return naturally.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, your smile can return naturally.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name} — if your heart feels heavy, your smile can return naturally.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, your smile can return naturally.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name}, if your heart feels heavy, the weight can get lighter.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, the weight can get lighter.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name} — if your heart feels heavy, the weight can get lighter.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, the weight can get lighter.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name}, if your heart feels heavy, you can stand taller again.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you can stand taller again.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "{name} — if your heart feels heavy, you can stand taller again.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you can stand taller again.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "{name}, if your heart feels heavy, a fresh start is still yours.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, a fresh start is still yours.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "{name} — if your heart feels heavy, a fresh start is still yours.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, a fresh start is still yours.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فبداية جديدة ما زالت لك."
    },
    {
        "en": "{name}, if your heart feels heavy, you can find yourself again.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you can find yourself again.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "{name} — if your heart feels heavy, you can find yourself again.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you can find yourself again.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "{name}, if your heart feels heavy, tomorrow can rewrite today.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, tomorrow can rewrite today.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "{name} — if your heart feels heavy, tomorrow can rewrite today.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, tomorrow can rewrite today.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "{name}, if your heart feels heavy, you are not alone in this.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فلست وحدك في هذا."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, you are not alone in this.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فلست وحدك في هذا."
    },
    {
        "en": "{name} — if your heart feels heavy, you are not alone in this.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فلست وحدك في هذا."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, you are not alone in this.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فلست وحدك في هذا."
    },
    {
        "en": "{name}, if your heart feels heavy, your future still believes in you.",
        "ar": "{name}، إذا كان قلبك ثقيلًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "Hey {name}, if your heart feels heavy, your future still believes in you.",
        "ar": "يا {name}، إذا كان قلبك ثقيلًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "{name} — if your heart feels heavy, your future still believes in you.",
        "ar": "{name} — إذا كان قلبك ثقيلًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "Dear {name}, if your heart feels heavy, your future still believes in you.",
        "ar": "عزيزي {name}، إذا كان قلبك ثقيلًا، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "{name}, if you lost something today, tomorrow can still lift you.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Hey {name}, if you lost something today, tomorrow can still lift you.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name} — if you lost something today, tomorrow can still lift you.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Dear {name}, if you lost something today, tomorrow can still lift you.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name}, if you lost something today, a softer day can still find you.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيوم ألطف قد يجدك."
    },
    {
        "en": "Hey {name}, if you lost something today, a softer day can still find you.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name} — if you lost something today, a softer day can still find you.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيوم ألطف قد يجدك."
    },
    {
        "en": "Dear {name}, if you lost something today, a softer day can still find you.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name}, if you lost something today, winning can still be near.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالفوز ما زال قريبًا."
    },
    {
        "en": "Hey {name}, if you lost something today, winning can still be near.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name} — if you lost something today, winning can still be near.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالفوز ما زال قريبًا."
    },
    {
        "en": "Dear {name}, if you lost something today, winning can still be near.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name}, if you lost something today, light can return without warning.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Hey {name}, if you lost something today, light can return without warning.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name} — if you lost something today, light can return without warning.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Dear {name}, if you lost something today, light can return without warning.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name}, if you lost something today, you can begin again.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Hey {name}, if you lost something today, you can begin again.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name} — if you lost something today, you can begin again.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Dear {name}, if you lost something today, you can begin again.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name}, if you lost something today, your story is not finished.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Hey {name}, if you lost something today, your story is not finished.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name} — if you lost something today, your story is not finished.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Dear {name}, if you lost something today, your story is not finished.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name}, if you lost something today, hope can grow back.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Hey {name}, if you lost something today, hope can grow back.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name} — if you lost something today, hope can grow back.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Dear {name}, if you lost something today, hope can grow back.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name}, if you lost something today, strength can wake with the morning.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Hey {name}, if you lost something today, strength can wake with the morning.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name} — if you lost something today, strength can wake with the morning.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Dear {name}, if you lost something today, strength can wake with the morning.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name}, if you lost something today, joy can visit again.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Hey {name}, if you lost something today, joy can visit again.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name} — if you lost something today, joy can visit again.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Dear {name}, if you lost something today, joy can visit again.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name}, if you lost something today, healing is already on the way.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Hey {name}, if you lost something today, healing is already on the way.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name} — if you lost something today, healing is already on the way.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Dear {name}, if you lost something today, healing is already on the way.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name}, if you lost something today, you can rise from this.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيمكنك النهوض من هذا."
    },
    {
        "en": "Hey {name}, if you lost something today, you can rise from this.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name} — if you lost something today, you can rise from this.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيمكنك النهوض من هذا."
    },
    {
        "en": "Dear {name}, if you lost something today, you can rise from this.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name}, if you lost something today, peace can come back to you.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالسلام قد يعود إليك."
    },
    {
        "en": "Hey {name}, if you lost something today, peace can come back to you.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالسلام قد يعود إليك."
    },
    {
        "en": "{name} — if you lost something today, peace can come back to you.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالسلام قد يعود إليك."
    },
    {
        "en": "Dear {name}, if you lost something today, peace can come back to you.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالسلام قد يعود إليك."
    },
    {
        "en": "{name}, if you lost something today, better moments are waiting.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Hey {name}, if you lost something today, better moments are waiting.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name} — if you lost something today, better moments are waiting.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Dear {name}, if you lost something today, better moments are waiting.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name}, if you lost something today, you are allowed a new chance.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيحق لك فرصة جديدة."
    },
    {
        "en": "Hey {name}, if you lost something today, you are allowed a new chance.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name} — if you lost something today, you are allowed a new chance.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيحق لك فرصة جديدة."
    },
    {
        "en": "Dear {name}, if you lost something today, you are allowed a new chance.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name}, if you lost something today, the next chapter can be kinder.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Hey {name}, if you lost something today, the next chapter can be kinder.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name} — if you lost something today, the next chapter can be kinder.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Dear {name}, if you lost something today, the next chapter can be kinder.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name}, if you lost something today, your heart can recover.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Hey {name}, if you lost something today, your heart can recover.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name} — if you lost something today, your heart can recover.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Dear {name}, if you lost something today, your heart can recover.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name}, if you lost something today, grace can meet you tomorrow.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Hey {name}, if you lost something today, grace can meet you tomorrow.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name} — if you lost something today, grace can meet you tomorrow.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Dear {name}, if you lost something today, grace can meet you tomorrow.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name}, if you lost something today, you will not stay here forever.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Hey {name}, if you lost something today, you will not stay here forever.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name} — if you lost something today, you will not stay here forever.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Dear {name}, if you lost something today, you will not stay here forever.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name}, if you lost something today, the sky can clear again.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Hey {name}, if you lost something today, the sky can clear again.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name} — if you lost something today, the sky can clear again.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Dear {name}, if you lost something today, the sky can clear again.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name}, if you lost something today, you can feel whole again.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Hey {name}, if you lost something today, you can feel whole again.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name} — if you lost something today, you can feel whole again.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Dear {name}, if you lost something today, you can feel whole again.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name}, if you lost something today, life can surprise you kindly.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Hey {name}, if you lost something today, life can surprise you kindly.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name} — if you lost something today, life can surprise you kindly.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Dear {name}, if you lost something today, life can surprise you kindly.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name}, if you lost something today, you can breathe easier soon.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Hey {name}, if you lost something today, you can breathe easier soon.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name} — if you lost something today, you can breathe easier soon.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Dear {name}, if you lost something today, you can breathe easier soon.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name}, if you lost something today, your smile can return naturally.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Hey {name}, if you lost something today, your smile can return naturally.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name} — if you lost something today, your smile can return naturally.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Dear {name}, if you lost something today, your smile can return naturally.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name}, if you lost something today, the weight can get lighter.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالوزن قد يصبح أخف."
    },
    {
        "en": "Hey {name}, if you lost something today, the weight can get lighter.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name} — if you lost something today, the weight can get lighter.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالوزن قد يصبح أخف."
    },
    {
        "en": "Dear {name}, if you lost something today, the weight can get lighter.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name}, if you lost something today, you can stand taller again.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Hey {name}, if you lost something today, you can stand taller again.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "{name} — if you lost something today, you can stand taller again.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Dear {name}, if you lost something today, you can stand taller again.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "{name}, if you lost something today, a fresh start is still yours.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فبداية جديدة ما زالت لك."
    },
    {
        "en": "Hey {name}, if you lost something today, a fresh start is still yours.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فبداية جديدة ما زالت لك."
    },
    {
        "en": "{name} — if you lost something today, a fresh start is still yours.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فبداية جديدة ما زالت لك."
    },
    {
        "en": "Dear {name}, if you lost something today, a fresh start is still yours.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فبداية جديدة ما زالت لك."
    },
    {
        "en": "{name}, if you lost something today, you can find yourself again.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "Hey {name}, if you lost something today, you can find yourself again.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "{name} — if you lost something today, you can find yourself again.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "Dear {name}, if you lost something today, you can find yourself again.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فيمكنك أن تجد نفسك من جديد."
    },
    {
        "en": "{name}, if you lost something today, tomorrow can rewrite today.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "Hey {name}, if you lost something today, tomorrow can rewrite today.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "{name} — if you lost something today, tomorrow can rewrite today.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "Dear {name}, if you lost something today, tomorrow can rewrite today.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فالغد قد يعيد كتابة اليوم."
    },
    {
        "en": "{name}, if you lost something today, you are not alone in this.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فلست وحدك في هذا."
    },
    {
        "en": "Hey {name}, if you lost something today, you are not alone in this.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فلست وحدك في هذا."
    },
    {
        "en": "{name} — if you lost something today, you are not alone in this.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فلست وحدك في هذا."
    },
    {
        "en": "Dear {name}, if you lost something today, you are not alone in this.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فلست وحدك في هذا."
    },
    {
        "en": "{name}, if you lost something today, your future still believes in you.",
        "ar": "{name}، إذا خسرت شيئًا اليوم، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "Hey {name}, if you lost something today, your future still believes in you.",
        "ar": "يا {name}، إذا خسرت شيئًا اليوم، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "{name} — if you lost something today, your future still believes in you.",
        "ar": "{name} — إذا خسرت شيئًا اليوم، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "Dear {name}, if you lost something today, your future still believes in you.",
        "ar": "عزيزي {name}، إذا خسرت شيئًا اليوم، فمستقبلك ما زال يؤمن بك."
    },
    {
        "en": "{name}, if you feel behind, tomorrow can still lift you.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Hey {name}, if you feel behind, tomorrow can still lift you.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name} — if you feel behind, tomorrow can still lift you.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "Dear {name}, if you feel behind, tomorrow can still lift you.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالغد ما زال قادرًا على رفعك."
    },
    {
        "en": "{name}, if you feel behind, a softer day can still find you.",
        "ar": "{name}، إذا شعرت أنك متأخر، فيوم ألطف قد يجدك."
    },
    {
        "en": "Hey {name}, if you feel behind, a softer day can still find you.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name} — if you feel behind, a softer day can still find you.",
        "ar": "{name} — إذا شعرت أنك متأخر، فيوم ألطف قد يجدك."
    },
    {
        "en": "Dear {name}, if you feel behind, a softer day can still find you.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فيوم ألطف قد يجدك."
    },
    {
        "en": "{name}, if you feel behind, winning can still be near.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالفوز ما زال قريبًا."
    },
    {
        "en": "Hey {name}, if you feel behind, winning can still be near.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name} — if you feel behind, winning can still be near.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالفوز ما زال قريبًا."
    },
    {
        "en": "Dear {name}, if you feel behind, winning can still be near.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالفوز ما زال قريبًا."
    },
    {
        "en": "{name}, if you feel behind, light can return without warning.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Hey {name}, if you feel behind, light can return without warning.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name} — if you feel behind, light can return without warning.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "Dear {name}, if you feel behind, light can return without warning.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالنور قد يعود بلا إنذار."
    },
    {
        "en": "{name}, if you feel behind, you can begin again.",
        "ar": "{name}، إذا شعرت أنك متأخر، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Hey {name}, if you feel behind, you can begin again.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name} — if you feel behind, you can begin again.",
        "ar": "{name} — إذا شعرت أنك متأخر، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "Dear {name}, if you feel behind, you can begin again.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فيمكنك أن تبدأ من جديد."
    },
    {
        "en": "{name}, if you feel behind, your story is not finished.",
        "ar": "{name}، إذا شعرت أنك متأخر، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Hey {name}, if you feel behind, your story is not finished.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name} — if you feel behind, your story is not finished.",
        "ar": "{name} — إذا شعرت أنك متأخر، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "Dear {name}, if you feel behind, your story is not finished.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فقصتك لم تنتهِ بعد."
    },
    {
        "en": "{name}, if you feel behind, hope can grow back.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Hey {name}, if you feel behind, hope can grow back.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name} — if you feel behind, hope can grow back.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "Dear {name}, if you feel behind, hope can grow back.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالأمل يمكن أن ينمو من جديد."
    },
    {
        "en": "{name}, if you feel behind, strength can wake with the morning.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Hey {name}, if you feel behind, strength can wake with the morning.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name} — if you feel behind, strength can wake with the morning.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "Dear {name}, if you feel behind, strength can wake with the morning.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالقوة قد تستيقظ مع الصباح."
    },
    {
        "en": "{name}, if you feel behind, joy can visit again.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Hey {name}, if you feel behind, joy can visit again.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name} — if you feel behind, joy can visit again.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "Dear {name}, if you feel behind, joy can visit again.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالفرح قد يزورك مجددًا."
    },
    {
        "en": "{name}, if you feel behind, healing is already on the way.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Hey {name}, if you feel behind, healing is already on the way.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name} — if you feel behind, healing is already on the way.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "Dear {name}, if you feel behind, healing is already on the way.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالشفاء في الطريق أصلًا."
    },
    {
        "en": "{name}, if you feel behind, you can rise from this.",
        "ar": "{name}، إذا شعرت أنك متأخر، فيمكنك النهوض من هذا."
    },
    {
        "en": "Hey {name}, if you feel behind, you can rise from this.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name} — if you feel behind, you can rise from this.",
        "ar": "{name} — إذا شعرت أنك متأخر، فيمكنك النهوض من هذا."
    },
    {
        "en": "Dear {name}, if you feel behind, you can rise from this.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فيمكنك النهوض من هذا."
    },
    {
        "en": "{name}, if you feel behind, peace can come back to you.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالسلام قد يعود إليك."
    },
    {
        "en": "Hey {name}, if you feel behind, peace can come back to you.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالسلام قد يعود إليك."
    },
    {
        "en": "{name} — if you feel behind, peace can come back to you.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالسلام قد يعود إليك."
    },
    {
        "en": "Dear {name}, if you feel behind, peace can come back to you.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالسلام قد يعود إليك."
    },
    {
        "en": "{name}, if you feel behind, better moments are waiting.",
        "ar": "{name}، إذا شعرت أنك متأخر، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Hey {name}, if you feel behind, better moments are waiting.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name} — if you feel behind, better moments are waiting.",
        "ar": "{name} — إذا شعرت أنك متأخر، فلحظات أفضل بانتظارك."
    },
    {
        "en": "Dear {name}, if you feel behind, better moments are waiting.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فلحظات أفضل بانتظارك."
    },
    {
        "en": "{name}, if you feel behind, you are allowed a new chance.",
        "ar": "{name}، إذا شعرت أنك متأخر، فيحق لك فرصة جديدة."
    },
    {
        "en": "Hey {name}, if you feel behind, you are allowed a new chance.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name} — if you feel behind, you are allowed a new chance.",
        "ar": "{name} — إذا شعرت أنك متأخر، فيحق لك فرصة جديدة."
    },
    {
        "en": "Dear {name}, if you feel behind, you are allowed a new chance.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فيحق لك فرصة جديدة."
    },
    {
        "en": "{name}, if you feel behind, the next chapter can be kinder.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Hey {name}, if you feel behind, the next chapter can be kinder.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name} — if you feel behind, the next chapter can be kinder.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "Dear {name}, if you feel behind, the next chapter can be kinder.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالفصل التالي قد يكون ألطف."
    },
    {
        "en": "{name}, if you feel behind, your heart can recover.",
        "ar": "{name}، إذا شعرت أنك متأخر، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Hey {name}, if you feel behind, your heart can recover.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name} — if you feel behind, your heart can recover.",
        "ar": "{name} — إذا شعرت أنك متأخر، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "Dear {name}, if you feel behind, your heart can recover.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فقلبك يمكن أن يتعافى."
    },
    {
        "en": "{name}, if you feel behind, grace can meet you tomorrow.",
        "ar": "{name}، إذا شعرت أنك متأخر، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Hey {name}, if you feel behind, grace can meet you tomorrow.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name} — if you feel behind, grace can meet you tomorrow.",
        "ar": "{name} — إذا شعرت أنك متأخر، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "Dear {name}, if you feel behind, grace can meet you tomorrow.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فاللطف قد يلقاك غدًا."
    },
    {
        "en": "{name}, if you feel behind, you will not stay here forever.",
        "ar": "{name}، إذا شعرت أنك متأخر، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Hey {name}, if you feel behind, you will not stay here forever.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name} — if you feel behind, you will not stay here forever.",
        "ar": "{name} — إذا شعرت أنك متأخر، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "Dear {name}, if you feel behind, you will not stay here forever.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فلن تبقى هنا إلى الأبد."
    },
    {
        "en": "{name}, if you feel behind, the sky can clear again.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Hey {name}, if you feel behind, the sky can clear again.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name} — if you feel behind, the sky can clear again.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالسماء قد تصفو من جديد."
    },
    {
        "en": "Dear {name}, if you feel behind, the sky can clear again.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالسماء قد تصفو من جديد."
    },
    {
        "en": "{name}, if you feel behind, you can feel whole again.",
        "ar": "{name}، إذا شعرت أنك متأخر، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Hey {name}, if you feel behind, you can feel whole again.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name} — if you feel behind, you can feel whole again.",
        "ar": "{name} — إذا شعرت أنك متأخر، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "Dear {name}, if you feel behind, you can feel whole again.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فيمكنك أن تشعر بالاكتمال من جديد."
    },
    {
        "en": "{name}, if you feel behind, life can surprise you kindly.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Hey {name}, if you feel behind, life can surprise you kindly.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name} — if you feel behind, life can surprise you kindly.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "Dear {name}, if you feel behind, life can surprise you kindly.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالحياة قد تفاجئك بلطف."
    },
    {
        "en": "{name}, if you feel behind, you can breathe easier soon.",
        "ar": "{name}، إذا شعرت أنك متأخر، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Hey {name}, if you feel behind, you can breathe easier soon.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name} — if you feel behind, you can breathe easier soon.",
        "ar": "{name} — إذا شعرت أنك متأخر، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "Dear {name}, if you feel behind, you can breathe easier soon.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فيمكنك أن تتنفس بأسهل قريبًا."
    },
    {
        "en": "{name}, if you feel behind, your smile can return naturally.",
        "ar": "{name}، إذا شعرت أنك متأخر، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Hey {name}, if you feel behind, your smile can return naturally.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name} — if you feel behind, your smile can return naturally.",
        "ar": "{name} — إذا شعرت أنك متأخر، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "Dear {name}, if you feel behind, your smile can return naturally.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فابتسامتك قد تعود طبيعيًا."
    },
    {
        "en": "{name}, if you feel behind, the weight can get lighter.",
        "ar": "{name}، إذا شعرت أنك متأخر، فالوزن قد يصبح أخف."
    },
    {
        "en": "Hey {name}, if you feel behind, the weight can get lighter.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name} — if you feel behind, the weight can get lighter.",
        "ar": "{name} — إذا شعرت أنك متأخر، فالوزن قد يصبح أخف."
    },
    {
        "en": "Dear {name}, if you feel behind, the weight can get lighter.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فالوزن قد يصبح أخف."
    },
    {
        "en": "{name}, if you feel behind, you can stand taller again.",
        "ar": "{name}، إذا شعرت أنك متأخر، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Hey {name}, if you feel behind, you can stand taller again.",
        "ar": "يا {name}، إذا شعرت أنك متأخر، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "{name} — if you feel behind, you can stand taller again.",
        "ar": "{name} — إذا شعرت أنك متأخر، فيمكنك أن تقف أطول من جديد."
    },
    {
        "en": "Dear {name}, if you feel behind, you can stand taller again.",
        "ar": "عزيزي {name}، إذا شعرت أنك متأخر، فيمكنك أن تقف أطول من جديد."
    }
];

export const getDayKey = (date = new Date()) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

export const hashString = (value) => {
    let hash = 2166136261;
    const str = String(value);
    for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
};

export const getDailyMotivationalQuote = ({ lang = 'en', name = '', userKey = '', date = new Date() } = {}) => {
    const dayKey = getDayKey(date);
    const index = hashString(`${dayKey}|${userKey}|${name}`) % MOTIVATIONAL_QUOTES.length;
    const quote = MOTIVATIONAL_QUOTES[index] || MOTIVATIONAL_QUOTES[0];
    const safeName = (name && String(name).trim()) || (lang === 'en' ? 'friend' : 'صديقي');
    const template = lang === 'en' ? quote.en : quote.ar;
    return {
        text: template.replace(/\{name\}/g, safeName),
        index,
        dayKey,
        total: MOTIVATIONAL_QUOTES.length,
    };
};

export default MOTIVATIONAL_QUOTES;
